/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Constants_SubscriptionTier } from '../models/Routemize_Constants_SubscriptionTier';
import type { Routemize_DTOs_Billing_CancelSubscriptionDto } from '../models/Routemize_DTOs_Billing_CancelSubscriptionDto';
import type { Routemize_DTOs_Billing_CreateSubscriptionDto } from '../models/Routemize_DTOs_Billing_CreateSubscriptionDto';
import type { Routemize_DTOs_Billing_DowngradeValidationResultDto } from '../models/Routemize_DTOs_Billing_DowngradeValidationResultDto';
import type { Routemize_DTOs_Billing_ReconcileAddonSeatsResultDto } from '../models/Routemize_DTOs_Billing_ReconcileAddonSeatsResultDto';
import type { Routemize_DTOs_Billing_SubscriptionUsageDto } from '../models/Routemize_DTOs_Billing_SubscriptionUsageDto';
import type { Routemize_DTOs_Billing_TenantSubscriptionDto } from '../models/Routemize_DTOs_Billing_TenantSubscriptionDto';
import type { Routemize_DTOs_Billing_UpdateSubscriptionDto } from '../models/Routemize_DTOs_Billing_UpdateSubscriptionDto';
import type { Routemize_DTOs_Billing_UserRemovalResultDto } from '../models/Routemize_DTOs_Billing_UserRemovalResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubscriptionService {
    /**
     * @returns Routemize_DTOs_Billing_TenantSubscriptionDto OK
     * @throws ApiError
     */
    public static getApiAppSubscriptionGetCurrentSubscription(): CancelablePromise<Routemize_DTOs_Billing_TenantSubscriptionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/subscription/getCurrentSubscription',
        });
    }
    /**
     * @returns Routemize_DTOs_Billing_SubscriptionUsageDto OK
     * @throws ApiError
     */
    public static getApiAppSubscriptionGetUsage(): CancelablePromise<Routemize_DTOs_Billing_SubscriptionUsageDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/subscription/getUsage',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_Billing_TenantSubscriptionDto OK
     * @throws ApiError
     */
    public static postApiAppSubscriptionCreateSubscription(
        requestBody?: Routemize_DTOs_Billing_CreateSubscriptionDto,
    ): CancelablePromise<Routemize_DTOs_Billing_TenantSubscriptionDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/subscription/createSubscription',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_Billing_TenantSubscriptionDto OK
     * @throws ApiError
     */
    public static postApiAppSubscriptionChangeSubscriptionTier(
        requestBody?: Routemize_DTOs_Billing_UpdateSubscriptionDto,
    ): CancelablePromise<Routemize_DTOs_Billing_TenantSubscriptionDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/subscription/changeSubscriptionTier',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppSubscriptionCancelSubscription(
        requestBody?: Routemize_DTOs_Billing_CancelSubscriptionDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/subscription/cancelSubscription',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Routemize_DTOs_Billing_TenantSubscriptionDto OK
     * @throws ApiError
     */
    public static postApiAppSubscriptionCancelScheduledChange(): CancelablePromise<Routemize_DTOs_Billing_TenantSubscriptionDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/subscription/cancelScheduledChange',
        });
    }
    /**
     * @returns Routemize_DTOs_Billing_TenantSubscriptionDto OK
     * @throws ApiError
     */
    public static postApiAppSubscriptionReactivateSubscription(): CancelablePromise<Routemize_DTOs_Billing_TenantSubscriptionDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/subscription/reactivateSubscription',
        });
    }
    /**
     * @returns Routemize_DTOs_Billing_TenantSubscriptionDto OK
     * @throws ApiError
     */
    public static postApiAppSubscriptionKeepSubscription(): CancelablePromise<Routemize_DTOs_Billing_TenantSubscriptionDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/subscription/keepSubscription',
        });
    }
    /**
     * @param featureName
     * @param requestedAmount
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAppSubscriptionCheckLimit(
        featureName?: string,
        requestedAmount: number = 1,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/subscription/checkLimit',
            query: {
                'featureName': featureName,
                'requestedAmount': requestedAmount,
            },
        });
    }
    /**
     * @param targetTier  Possible values: Solo = 0, Pro = 1, Scale = 2
     * @returns Routemize_DTOs_Billing_DowngradeValidationResultDto OK
     * @throws ApiError
     */
    public static postApiAppSubscriptionValidateChange(
        targetTier?: Routemize_Constants_SubscriptionTier,
    ): CancelablePromise<Routemize_DTOs_Billing_DowngradeValidationResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/subscription/validateChange',
            query: {
                'targetTier': targetTier,
            },
        });
    }
    /**
     * @returns Routemize_DTOs_Billing_TenantSubscriptionDto OK
     * @throws ApiError
     */
    public static postApiAppSubscriptionAddUserSeat(): CancelablePromise<Routemize_DTOs_Billing_TenantSubscriptionDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/subscription/addUserSeat',
        });
    }
    /**
     * @returns Routemize_DTOs_Billing_TenantSubscriptionDto OK
     * @throws ApiError
     */
    public static deleteApiAppSubscriptionRemoveUserSeat(): CancelablePromise<Routemize_DTOs_Billing_TenantSubscriptionDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/subscription/removeUserSeat',
        });
    }
    /**
     * @returns Routemize_DTOs_Billing_UserRemovalResultDto OK
     * @throws ApiError
     */
    public static getApiAppSubscriptionGetUnusedSeatsInfo(): CancelablePromise<Routemize_DTOs_Billing_UserRemovalResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/subscription/getUnusedSeatsInfo',
        });
    }
    /**
     * @returns Routemize_DTOs_Billing_ReconcileAddonSeatsResultDto OK
     * @throws ApiError
     */
    public static postApiAppSubscriptionReconcileAddonSeats(): CancelablePromise<Routemize_DTOs_Billing_ReconcileAddonSeatsResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/subscription/reconcileAddonSeats',
        });
    }
}
